export default "__VITE_ASSET__CG2rFQ8S__"